// extracted by mini-css-extract-plugin
module.exports = {"columns":"StoxSolutions_columns__Mr2q4","infoLeft":"StoxSolutions_infoLeft__QJC8k","infoCol":"StoxSolutions_infoCol__O0sir","content":"StoxSolutions_content__nhzs_"};